export default __webpack_public_path__ + "d4bdb50fe8d74faab9ddbb8565309d75.png";